module.exports = __webpack_public_path__ + "media/images/it/icons/linkedin-929752e298dda004a188f7a915518050.svg";